import useAsyncEffect from '../use-async-effect';

import {Dispatch, SetStateAction, useState} from 'react';

function useAsyncState<T, DefaultValueType = T>(
  asyncFunction: () => Promise<T>,
  defaultValue: T | DefaultValueType,
  dependencies: $TSFixMe[] = []
): [T | typeof defaultValue, Dispatch<SetStateAction<T | typeof defaultValue>>] {
  const [state, setState] = useState<T | typeof defaultValue>(defaultValue);

  useAsyncEffect(async () => {
    const result = await asyncFunction();
    setState(result);
  }, dependencies);

  return [state, setState];
}

export default useAsyncState;
